import { render } from "./LottieCustom.vue?vue&type=template&id=709fd40e"
import script from "./LottieCustom.vue?vue&type=script&lang=js"
export * from "./LottieCustom.vue?vue&type=script&lang=js"

import exportComponent from "/lendr-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__